<div class="error-page">
  <div class="error-card">
    <div class="error-icon">
      <svg-icon src="assets/icons/file-search.svg" [svgStyle]="{ 'width.px': 26, 'height.px': 26 }"></svg-icon>
    </div>
    <div class="error-num">404</div>
    <div class="error-num-text">Page not found</div>
    <h1 class="error-title">We couldn't find that page</h1>
    <p class="error-desc">The page you're looking for doesn't exist or may have been moved. Double-check the URL or navigate back to a known section.</p>
    <div class="error-actions">
      <button nz-button nzType="primary" nzShape="round" (click)="goBack()">
        <svg-icon src="assets/icons/arrow-left.svg" class="btn-icon btn-icon--light" aria-hidden="true"></svg-icon>
        Go back
      </button>
      <button nz-button nzType="default" nzShape="round" (click)="goHome()">
        <svg-icon src="assets/icons/home.svg" class="btn-icon" aria-hidden="true"></svg-icon>
        Home
      </button>
    </div>
  </div>
</div>
